import {
  InstructorCreate,
  InstructorEdit,
  InstructorList
} from 'pages/ecommerce/instructors';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'instructors',
  label: 'Instrutores',
  list: InstructorList,
  create: InstructorCreate,
  edit: InstructorEdit,
  actions: ['list', 'show', 'edit', 'create', 'delete', 'slug'],
  parentName: 'ecommerce'
};

export default generateResources(resource);
